export default __webpack_public_path__ + "static/media/FOTO-HOAKS-PFIZER-1.18e92f4f.png";